/*=============================================== TextPage ===============================================*/

import { Link } from "react-router-dom"
import { Text, Flexbox } from "tsx-library-julseb"

import { ComponentsLayout } from "components"
import type { ItemType, PropsItemType } from "components"

import { commonProps } from "data"

const TextPage = () => {
    const items: ItemType[] = [
        {
            title: "Titles display",
            content: (
                <Flexbox flexDirection="column">
                    <Text tag="h1" display>
                        Title h1 display
                    </Text>

                    <Text tag="h2" display>
                        Title h2 display
                    </Text>

                    <Text tag="h3" display>
                        Title h3 display
                    </Text>

                    <Text tag="h4" display>
                        Title h4 display
                    </Text>

                    <Text tag="h5" display>
                        Title h5 display
                    </Text>
                </Flexbox>
            ),
            code: '<Text tag="h1" display>Title h1 display</Text>\n<Text tag="h2" display>Title h2 display</Text>\n<Text tag="h3" display>Title h3 display</Text>\n<Text tag="h4" display>Title h4 display</Text>\n<Text tag="h5" display>Title h5 display</Text>',
        },
        {
            title: "Titles",
            content: (
                <Flexbox flexDirection="column">
                    <Text tag="h1">Title h1</Text>
                    <Text tag="h2">Title h2</Text>
                    <Text tag="h3">Title h3</Text>
                    <Text tag="h4">Title h4</Text>
                    <Text tag="h5">Title h5</Text>
                    <Text tag="h6">Title h6</Text>
                </Flexbox>
            ),
            code: '<Text tag="h1">Title h1</Text>\n<Text tag="h2">Title h2</Text>\n<Text tag="h3">Title h3</Text>\n<Text tag="h4">Title h4</Text>\n<Text tag="h5">Title h5</Text>\n<Text tag="h6">Title h6</Text>',
        },
        {
            title: "Paragraphs",
            content: (
                <Flexbox flexDirection="column">
                    <Text tag="p">Paragraph</Text>

                    <Text tag="p">
                        Paragraph <Text tag="strong">strong</Text>
                    </Text>
                    <Text tag="p">
                        Paragraph <Text tag="em">italic</Text>
                    </Text>
                    <Text tag="p">
                        Paragraph with <Link to="#">link</Link>
                    </Text>
                    <Text tag="p">
                        Paragraph <code>code</code>
                    </Text>
                </Flexbox>
            ),
            code: '<Text tag="p">Paragraph</Text>\n<Text tag="p">Paragraph <Text tag="strong">strong</Text></Text>\n<Text tag="p">Paragraph <Text tag="em">italic</Text></Text>\n<Text tag="p">Paragraph with <Link to="#">link</Link></Text>\n<Text tag="p">Paragraph <code>code</code></Text>',
        },
        {
            title: "Small",
            content: <Text tag="small">Small</Text>,
            code: '<Text tag="small">Small</Text>',
        },
        {
            title: "Blockquote",
            content: <Text tag="blockquote">Blockquote</Text>,
            code: '<Text tag="blockquote">Blockquote</Text>',
        },
        {
            title: "Unordered list",
            content: (
                <Text tag="ul">
                    <li>Unordered list</li>
                    <li>Unordered list</li>
                    <li>Unordered list</li>
                    <li>Unordered list</li>
                    <li>Unordered list</li>
                </Text>
            ),
            code: '<Text tag="ul">\n    <li>Unordered list</li>\n</Text>',
        },
        {
            title: "Ordered list",
            content: (
                <Text tag="ol">
                    <li>Ordered list</li>
                    <li>Ordered list</li>
                    <li>Ordered list</li>
                    <li>Ordered list</li>
                    <li>Ordered list</li>
                </Text>
            ),
            code: '<Text tag="ol">\n    <li>Ordered list</li>\n</Text>',
        },
        {
            title: "Description list",
            content: (
                <Text tag="dl">
                    <dt>Description list title</dt>
                    <dd>Description list content</dd>
                    <dt>Description list title</dt>
                    <dd>Description list content</dd>
                    <dt>Description list title</dt>
                    <dd>Description list content</dd>
                    <dt>Description list title</dt>
                    <dd>Description list content</dd>
                    <dt>Description list title</dt>
                    <dd>Description list content</dd>
                </Text>
            ),
            code: '<Text tag="dl">\n    <dt>Description list title</dt>\n    <dd>Description list content</dd>\n</Text>',
        },
    ]

    const propsItems: PropsItemType[] = [
        {
            subtitle: "as",
            intro: "Changes the HTML tag",
            type: "string",
            possibleString: "Any HTML tag",
            default: <>Same as tag prop</>,
        },
        {
            subtitle: "tag",
            type: "string",
            possible: [
                "h1",
                "h2",
                "h3",
                "h4",
                "h5",
                "h6",
                "p",
                "strong",
                "em",
                "small",
                "blockquote",
                "ul",
                "ol",
                "dl",
            ],
            default: "p",
        },
        {
            subtitle: "textAlign",
            type: "string",
            possible: commonProps.textAlign,
        },
        {
            subtitle: "display",
            intro: (
                <>
                    From <code>h1</code> to <code>h5</code>.
                </>
            ),
            type: "boolean",
        },
    ]

    return <ComponentsLayout items={items} propsItems={propsItems} />
}

export default TextPage
